/**
 * @generated SignedSource<<b4374c8d1d2a48913885f45cc30a0677>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityHistory_entity$data = {
  readonly logs: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityHistoryEntry_entry">;
  }>;
  readonly " $fragmentType": "EntityHistory_entity";
};
export type EntityHistory_entity$key = {
  readonly " $data"?: EntityHistory_entity$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistory_entity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityHistory_entity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LogEntry",
      "kind": "LinkedField",
      "name": "logs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EntityHistoryEntry_entry"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Logable",
  "abstractKey": "__isLogable"
};

(node as any).hash = "ef9c2dc0119ddb10fffe7d488be16325";

export default node;
